var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderStatusesList',{attrs:{"businessOrderStatusTitleList":_vm.businessOrderStatusTitleList,"businessId":_vm.businessId}})
}
var staticRenderFns = []

export { render, staticRenderFns }